import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import CustomerCart from '../../CustomerCart'
import Typography from '../../Typography'
import styles from './OrderComplete.module.sass'
import Order from '../../../models/Order'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { OrderPackage } from '../../../models';
import useQueryString from '../../../hooks/use-query-string';
import AppointmentOrderComplete from './AppointmentOrderComplete';

const useOrder = (orderId, email) => {
  const [order, setOrder] = useState([])
  const [page, setPage] = useState(1);

  useEffect(() => {
    const orderPackageScope = OrderPackage.page(page).per(5);

    Order
      .merge({ orderPackages: orderPackageScope })
      .includes({
        cart: ['coupon', {
          orderPackages: [
            'background',
            'package',
            'seniorImage',
            'studentImage',
            { student: 'school' },
            { api_option: 'image_types' },
            { extras: 'prices' },
          ],
        }],
      })
      .where({ for_email: [orderId, email] })
      .first()
      .then((response) => {
        if (response.data.cart.orderPackages.length > 0) {
          if (Array.isArray(order)) {
            setOrder(response.data);
          } else {
            order.cart.orderPackages = [...order.cart.orderPackages, ...response.data.cart.orderPackages];
            setOrder(order);
          }

          setPage((prev) => prev + 1);
        }
      })
  }, [orderId, email, page])

  return order
}

const OrderComplete = () => {
  const { order_id: orderId, email: email } = useParams()
  const order = useOrder(orderId, email)
  const { clearCart } = useContext(CustomerContext)

  const { app } = useQueryString();

  useEffect(() => {
    clearCart();
  }, []);

  if (typeof order !== 'object') return null
  if (!order) return null

  if (app && app !== 'undefined') {
    if (!order.id) return null;

    return <AppointmentOrderComplete order={order} />
  }

  return (
    <div className={styles.container}>
      <Typography align="center" weight={500}>ORDER CONFIRMATION</Typography>
      <Typography align="center" weight={600}>
        Order
        #
        {order.id}
      </Typography>
      <Typography
        align="center"
        weight={700}
        classes={styles.thankYouMsg}
      >
        Thank you for your purchase from Shoob Photography!
      </Typography>

      <CustomerCart displayPurchaseInfo isPurchased editable={false} providedCart={order.cart}
                    order={order} email={email} key='order-complete' />
    </div>
  )
}

export default OrderComplete
